import { motion } from 'motion/react'
import React from 'react'

import clsx from 'clsx'
import Image from 'next/image'

// prettier-ignore
const defaultTextProps = {
  heading: 'Turn your locations, lists and business data into interactive maps in seconds — no stress, no setup.'
}

export function HowItWorks(props) {
  const { textProps = defaultTextProps } = props
  return (
    <div className='pt-[56px] flex gap-[16px] flex-col'>
      <div
        className={clsx(
          'mx-auto flex w-[1005px] items-start justify-center gap-[8px]',
          'max-[991px]:w-[600px]',
          'max-[768px]:w-full max-[768px]:px-[16px]'
        )}
      >
        <h3
          className={clsx(
            'mb-0 text-center text-[52px] leading-[110%] font-[700] tracking-tight',
            'max-[991px]:text-[32px]',
            'max-[768px]:text-[8vw]'
          )}
        >
          {textProps?.heading}
        </h3>
      </div>

      <div
        className={clsx(
          'mx-auto max-w-[1280px] px-0 self-center flex-1 pb-[120px]',
          'max-[768px]:w-full'
        )}
      >
        {props.children}
      </div>
    </div>
  )
}

interface HowItWorkProps {
  reverse?: boolean
  icon?: any
  eyebrow: string
  heading: string
  description: string
  cta: string
  src: any
  href: string
}

export function HowItWork(props: HowItWorkProps) {
  const Icon = props?.icon || React.Fragment

  return (
    <div
      className={clsx(
        'my-[100px] flex items-center justify-between gap-[16px]',
        'max-[991px]:px-[24px]  max-[991px]:items-center max-[991px]:mb-0 max-[991px]:mt-[40px]',
        'max-[768px]:width-[100vw] max-[768px]:flex-col max-[768px]:px-[18px] max-[768px]:items-stretch',
        {
          'flex-row-reverse': props.reverse,
          'flex-row': !props.reverse
        }
      )}
    >
      <div
        className={clsx(
          'mx-[40px] flex max-w-[450px] flex-col items-start',
          'max-[991px]:mx-0 max-[991px]:pl-[16px]',
          'max-[768px]:pl-[36px] max-[768px]:pr-[80px] max-[768px]:max-w-none'
        )}
      >
        <div className='mb-[16px] flex h-[44px] w-auto items-center rounded-[10px] bg-white px-[16px] py-[12px] shadow'>
          <Icon
            weight='duotone'
            size={22}
            className='text-brand-05'
          />
          <div
            className={clsx(
              'text-brand-05 ml-[8px] text-[17px] leading-[110%] font-[700]',
              'max-[991px]:text-[16px]'
            )}
          >
            {props.eyebrow}
          </div>
        </div>
        <div>
          <h2
            className={clsx(
              'mb-[16px] max-w-[514px] text-[36px] leading-[110%] font-[700]',
              'max-[991px]:text-[26px]'
            )}
          >
            {props.heading}
          </h2>
        </div>
        <p
          className={clsx(
            'mb-[24px] tracking-normal text-[19px] leading-[130%] text-gray-400',
            'max-[991px]:text-[15px]'
          )}
        >
          {props.description}
        </p>
        <motion.a
          href={props.href}
          className={clsx(
            'bg-brand-02 rounded-xl px-[24px] py-[16px] text-[17px] leading-[100%] font-[500] text-white'
          )}
          whileHover={{
            scale: 1.1,
            transition: { duration: 0.2 }
          }}
        >
          {props.cta}
        </motion.a>
      </div>
      <div
        className={clsx(
          'relative flex w-[70%] h-full items-center justify-end',
          'max-[991px]:w-auto max-[991px]:max-w-none',
          'max-[768px]:w-full max-[768px]:max-w-none'
        )}
      >
        <Image
          src={props.src}
          alt={props.heading}
          width={558}
          height={339}
          className='max-[768px]:w-full'
        />
      </div>
    </div>
  )
}
